<template>
    <div class="sf-community-host">
      <template v-if="visibleHost">
        <p class="sf-host-eyebrow">A PERSON TO SAY HELLO TO</p>
        <h2>Meet your community host.</h2>

        <div class="sf-host-person">
          <img
            :src="hostPhoto"
            :alt="hostName"
          />
          <div>
            <h3>{{ hostName }}</h3>
            <p>Community host</p>
          </div>
        </div>

        <p class="sf-host-description">
          Have a question or thinking about visiting?
          {{ hostFirstName || 'Your host' }} can help you get connected.
        </p>

        <button type="button" class="sf-host-button" @click="connect">
          {{ hostFirstName ? 'Contact ' + hostFirstName : 'Contact your host' }}
        </button>
      </template>

      <template v-else>
        <p class="sf-host-eyebrow">YOUR NEXT STEP</p>
        <h2>Get in touch</h2>
        <p class="sf-host-description">
          Check with {{ community.title }} for current gathering details
          and information about your first visit.
        </p>

        <a
          v-if="community.website"
          :href="community.website"
          class="sf-host-button"
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit community website ↗
        </a>

        <p v-else class="sf-host-description">
          Contact details aren’t available on this listing yet.
        </p>
      </template>
    </div>
  </template>

  <script>
  import { usableHostFirstName } from './hostName'

  export default {
    name: 'HostCard',

    props: {
      community: {
        type: Object,
        required: true
      },
      username: String
    },

    computed: {
      visibleHost () {
        const host = this.community.host;
        return Boolean(
          host &&
          !this.community.hide_host &&
          host.username !== 'storyfaith-web-test'
        );
      },

      hostFirstName () {
        return usableHostFirstName(this.community.host);
      },

      hostName () {
        const host = this.community.host || {};
        return [host.first_name, host.last_name]
          .filter(Boolean)
          .join(' ') || 'Community host';
      },

      hostPhoto () {
        const host = this.community.host || {};
        const profile = host.profile || {};
        return profile.thumbnail || '/static/communities/user-no-pic.png';
      }
    },

    methods: {
      connect () {
        this.$emit('connect');
      }
    }
  }
  </script>

  <style scoped>
  .sf-host-eyebrow {
    margin: 0 0 12px;
    color: #62695f;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: .12em;
  }

  .sf-community-host h2 {
    font-family: Georgia, serif;
    font-size: 24px;
    font-weight: 400;
    margin: 0 0 22px;
    color: #26362e;
  }

  .sf-host-person {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 20px;
  }

  .sf-host-person img {
    width: 56px;
    height: 56px;
    object-fit: cover;
    border-radius: 50%;
  }

  .sf-host-person h3 {
    margin: 0 0 3px;
    font-size: 14px;
    font-weight: 700;
  }

  .sf-host-person p {
    margin: 0;
    font-size: 12px;
    color: #62695f;
  }

  .sf-host-description {
    font-size: 13px;
    line-height: 1.8;
    color: #62695f;
  }

  .sf-host-button {
    display: block;
    width: 100%;
    padding: 13px 16px;
    border: 0;
    border-radius: 9px;
    background: #26362e;
    color: #fff;
    font-family: 'Open Sans', sans-serif;
    font-size: 13px;
    font-weight: 700;
    line-height: 1.5;
    text-align: center;
    text-decoration: none;
    cursor: pointer;
  }
  </style>
